<admin-controller [parentForm]="adminForm" label="Workflow"/>
